module.exports = __webpack_public_path__ + "img/A2_1.2ead30bc.png";